<template>
    <main-layout class="min-h-dvh flex flex-col">
        <app-header class="bg-gradient-to-b from-secondary to-primary pb-8"></app-header>
        <nav
            class="bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-[1.5rem] relative z-20 isolate shadow-xl -mt-6 py-8 px-2 flex-1 overflow-y-auto pb-28">
            <a id="btn-offline"
                class="relative mx-4 mb-4 p-3 bg-orange text-white rounded-xl flex items-center justify-between shadow-lg uppercase"
                v-if="actions.length > 0" @click.prevent="trySync('synchro')">

                <!-- Badge en haut à droite -->
                <i v-if="actions.length > 0"
                    class="actions absolute -top-2 -right-2 z-10 shadow-md bg-alert text-white font-bold text-sm flex items-center justify-center h-6 w-6 rounded-full">
                    {{ actions.length }}
                </i>

                <span class="text-left">
                    <strong>Actions</strong><br>
                    Non synchronisées
                </span>

                <i class="inline-block h-12 w-12 mask mask-reload bg-white opacity-50"></i>
            </a>

            <a id="btn-sync"
                class="mx-4 mb-4 p-3 bg-orange text-white rounded-xl flex items-center justify-between shadow-lg uppercase"
                v-if="actions.length <= 0" @click.prevent="trySync('init')">
                <span class="text-2xl">
                    <strong>Synchroniser</strong>
                    Les données
                </span>
                <i class="inline-block h-12 w-12 mask mask-reload bg-white opacity-50"></i>
            </a>

            <span class="if" v-if="type === 'technicien'">

                <router-link id="btn-interventions"
                    class="relative mx-4 mb-4 p-3 bg-secondary text-white rounded-xl flex items-center justify-between shadow-lg"
                    to="liste-fibsdd">
                    <i v-if="this.numberFibsdd() > 0" class="actions absolute -top-2 -right-2 z-10 shadow-md">
                        {{ this.numberFibsdd() }}
                    </i>

                    <span class="text-2xl font-semibold">Intervention{{ this.numberFibsdd() > 1 ? 's' : '' }}</span>
                    <i class="inline-block h-12 w-12 mask mask-gear bg-white opacity-25"></i>
                </router-link>


                <div class="mx-4 grid grid-cols-2 gap-4 mb-6">
                    <router-link id="btn-contrat" class="relative bg-white rounded-lg shadow w-full h-24"
                        to="contrat-assemblage">
                        <i class="absolute top-2 right-2 h-8 w-8 mask mask-file bg-secondary"></i>
                        <span class="absolute bottom-5 left-2 text-primary text-lg sm:text-xl">
                            Contrat<br>
                            <strong>d'assemblage</strong>
                        </span>
                    </router-link>
                    <router-link id="btn-interventions-d" class="relative bg-white rounded-lg shadow w-full h-24"
                        to="ctrl-multi">
                        <!-- Icône -->
                        <i class="absolute top-2 right-2 h-8 w-8 mask mask-pipe-valve bg-secondary"></i>

                        <!-- Texte -->
                        <span class="absolute left-3 top-1/2 -translate-y-1/2 text-primary text-sm sm:text-base md:text-lg leading-tight">
                            <strong>
                                Contrôles
                                <br class="block md:hidden">
                                d’étanchéité
                            </strong>
                            <br>
                            périodiques - multiples
                        </span>
                    </router-link>

                </div>

            </span>

            <router-link id="btn-detenteurs"
                class="relative mx-4 mb-4 p-3 bg-primary text-white rounded-xl flex items-center justify-between shadow-lg"
                to="liste-detenteurs">
                <span class="text-2xl">
                    <strong>Détenteurs</strong>
                    & installations
                </span>

                <i class="inline-block h-12 w-12 mask mask-factory bg-white opacity-50"></i>
            </router-link>

            <div class="mx-4 grid grid-cols-2 gap-4 mb-4">
                <router-link id="btn-bouteilles" class="relative bg-white rounded-lg shadow w-full h-20"
                    to="liste-bouteilles">
                    <!-- Icône en haut à droite -->
                    <i class="absolute top-2 right-2 h-8 w-8 mask mask-bouteille bg-secondary"></i>
                    <!-- Texte en bas à gauche -->
                    <span class="absolute bottom-2 left-2 text-primary text-xl sm:text-2xl">
                        Bouteilles
                    </span>
                </router-link>

                <router-link v-if="type === 'technicien'" class="relative bg-white rounded-lg shadow w-full h-20"
                    id="btn-outils" to="liste-outils">
                    <!-- Icône en haut à droite -->
                    <i class="absolute top-2 right-2 h-8 w-8 mask mask-tools bg-secondary"></i>
                    <!-- Texte en bas à gauche -->
                    <span class="absolute bottom-2 left-2 text-primary text-xl sm:text-2xl">
                        Outillage
                    </span>
                </router-link>
            </div>

            <!-- div v-if="this.hasPlanning === true">
                <a class="btn tutobtn sml" target="_blank" v-show="token"
                    :href="`https://admin.fi360.fr/tutorials?token=${token}`">
                    <span>
                        <strong>TUTORIELS</strong>
                        F.i360°
                    </span>
                    <i class="icon-go"></i>
                </a>

                <router-link class="btn sml btn-planning" to="agenda">
                    <i class="icon-calend"></i>
                    <span>Planning</span>
                    <span v-if="this.nbEvent > 0" class="notifications" style="
                        width: 20px;
                        height: 20px;
                        border-radius: 50%;
                        background-color: #c31616;
                        position: absolute;
                        left: 126px;
                        top: 29px;
                    "></span>
                </router-link>
<a v-else class="btn tutobtn" target="_blank" v-show="token"
            </!-->

            <a class="mx-4 mb-30 p-4 bg-gris text-white rounded-lg flex items-center justify-between" target="_blank"
                v-show="token" :href="`https://admin.fi360.fr/tutorials?token=${token}`">
                <!-- Conteneur pour les deux titres -->
                <div class="flex flex-col">
                    <h2 class="text-2xl font-bold">Tutoriels</h2>
                </div>

                <!-- Icône à droite -->
                <i class="inline-block h-12 w-12 mask mask-info bg-white opacity-30"></i>
            </a>

            <!--<div>
                <button id="btn-support" style="display: none;">
                    Support
                    <div class="indicator" v-if="badgeCount > 0">
                        <div class="noti_count" role="status">{{ badgeCount }}</div>
                    </div>
                </button>
            </div>
            -->

        </nav>

    </main-layout>
</template>

<script>

import Offline from '../../js/models/Offline'
import User from '../../js/models/User'
import Operateur from "../../js/models/Operateur";
import Planning from "../../js/models/Planning";
import History from "../../js/core/History";

export default {

    data() {
        return {
            actions: [],
            type: null,
            token: null,
            inters: 0,
            hasPlanning: false,
            nbEvent: 0
        }
    },
    computed: {
        badgeCount() {
            return this.$root.badgeCount;
        }
    },

    methods: {

        numberFibsdd() {
            localforage.getItem('listFibsdd').then(fi => {
                fi = JSON.parse(fi);
                fi = fi.filter(f => f.cloture === false);
                this.inters = fi.length;
            }).catch();
            return this.inters;
        },
        checkSignature() {
            User
                .getUserData(usr => {
                    if (!usr.signature64) {
                        this.$router.push('configuration')
                    }
                })
        },

        lock(e) {
            e.preventDefault();
            swal('Indisponible', 'Cette fonctionnalité sera disponible prochainement', 'error')
        },

        fetchOfflineActions() {
            Offline
                .getList()
                .then(data => {
                    this.actions = data
                })
                .catch()
        },

        trySync(type) {
            if (!navigator.onLine) {
                swal('Pas de connexion internet', 'Veuillez vous connecter à internet pour pouvoir vous synchroniser avec le serveur.', 'error')
            } else {

                //return console.log('here');

                let router = this.$router;

                if (type === 'synchro') {
                    swal({
                        title: 'Envoi des données',
                        text: "Êtes-vous sûr de vouloir envoyer vos données au serveur ? Assurez vous d'avoir une bonne connexion réseau.",
                        type: 'question',
                        showCancelButton: true,
                        cancelButtonText: 'Non',
                        confirmButtonText: 'Oui'
                    }).then(
                        () => {

                            return router.push({ name: type })
                        },
                        () => { swal.close() }
                    )
                } else {
                    return router.push({ name: type })
                }
            }

        }

    },

    mounted() {
        localforage.getItem('api-token').then(token => this.token = token).catch();
        this.fetchOfflineActions();
        this.checkSignature();
        User.getUserData(data => this.type = data.type)


        Operateur.getOperateurOption(options => {
            this.hasPlanning = options.includes('planning');
        })

        Planning.getNotifications(notifications => {
            this.nbEvent = notifications.nbEvent;
        })

        History.initialisation();


    }
}

</script>



// WEBPACK FOOTER //
// Home.vue?5044a72a